export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9403.54a58dbf.jpg";